import type { ElementType, KeyboardEvent, MouseEvent, ReactNode } from 'react';
import './Card.css';

interface CardProps {
  as?: ElementType;
  onClick?: () => void;
  className?: string;
  children?: ReactNode;
}

export default function Card({
  as: Tag = 'div',
  onClick,
  className,
  children
}: CardProps) {
  const isClickable = !!onClick;

  const handleKeyPress = (e: KeyboardEvent) => {
    if (onClick && (e.key === ' ' || e.key === 'Enter')) {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <Tag
      className={`Card${isClickable ? ' Card--clickable' : ''}${className ? ` ${className}` : ''}`}
      role={isClickable ? 'button' : undefined}
      tabIndex={isClickable ? 0 : undefined}
      onClick={
        isClickable
          ? (e: MouseEvent) => {
              e.preventDefault();
              onClick();
            }
          : undefined
      }
      onKeyDown={handleKeyPress}
    >
      {children}
    </Tag>
  );
}
